import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
// eslint-disable-next-line
import { Swiper, SwiperSlide } from "swiper/react";
import Sync from '../../../../Assets/uploadCloud.png';
import Uploader from '../../../../Assets/together.png';
import CircleLeft from '../../../../Assets/circleLeft.png';
import CircleRight from '../../../../Assets/circleRight.png';
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css"; // ✅ Import full Swiper styles
import styles from './index.module.css';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  borderRadius: 4,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 6,
};
function TutorialCloud({ openTutorailModal, setOpenTutorailModal }) {
  const handleClose = () => {
    localStorage.setItem('tutorialCloud', false);
    setOpenTutorailModal(false);
  };
  const swiperRef = useRef(null);
  const tutorialSlide = [
    {
      header: 'Welcome to Projector Cloud',
      title: 'Uploading made simple',
      description:
        'Is publishing a video on stream taking too much time? Our projector upload can get your projector account setup in under 10 minutes.',
      image: Uploader,
    },
    {
      header: 'Add your files to uploader',
      title: 'Sync your files',
      description:
        'Sync your files or manually upload files to Projector. You can later publish them in Stream anytime you want.',
      image: Sync,
    },
    {
      header: 'Welcome to Projector Cloud',
      title: 'Upload everything to feed',
      description:
        'Is publishing a video on stream taking too much time? Our projector upload can get your projector account setup in under 10 minutes.',
      image: Uploader,
    },
  ];
  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={openTutorailModal}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openTutorailModal}>
          <Box sx={style}>
            {/* ✅ Move buttons INSIDE here */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <button
                className={styles.leftButton}
                onClick={() => swiperRef.current?.slidePrev()}
              >
                <img src={CircleLeft} alt="" />
              </button>
              <button
                className={styles.rightButton}
                onClick={() => swiperRef.current?.slideNext()}
              >
                <img src={CircleRight} alt="" />
              </button>
            </Box>

            <Swiper
              // eslint-disable-next-line
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              spaceBetween={20}
              slidesPerView={1}
              pagination={{ clickable: true }}
              loop
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
            >
              {tutorialSlide.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div>
                    <h1 className={styles.header_one}>{slide.header}</h1>
                    <div className={styles.flexContainer}>
                      <div className={styles.imgDiv}>
                        <img
                          className={styles.eachbyimg}
                          src={slide.image}
                          alt="Slide Icon"
                        />
                      </div>
                      <div className={styles.topAlgin}>
                        <p className={styles.header}>{slide.title}</p>
                        <p className={styles.sub_header}>{slide.description}</p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default TutorialCloud;
